import TeacherStatementTable from "./TeacherStatementTable";

export default TeacherStatementTable